const ConfigurationList = async () =>
    import('../../pages/email-to-transport/List').then((module) => ({
        Component: module.EmailToTransportList,
    }));
const ConfigurationView = async () =>
    import('../../pages/email-to-order/View').then((module) => ({
        Component: module.EmailToOrderView,
    }));

const getEmailToTransportRouter = (_user, _features) => [
    {
        path: '/transport-configs',
        lazy: ConfigurationList,
    },
    {
        path: '/transport-configs/:id',
        lazy: ConfigurationView,
    },
];

export { getEmailToTransportRouter };
